/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { getMachineCurrentLocationName } from "utils/machineCurrentLocation";
import machineDisplayName from "layouts/machine/data/machineDisplayName";


export default function inactiveMachineTableData({ eliminated }) {
  return {
    columns: [
      { Header: "Tipo", accessor: "MachineTypeType", align: "left" },
      {
        Header: "Nombre",
        accessor: "Name",
        align: "left",
        Cell: ({ value }) => (
          <span style={{ display: "inline-block", maxWidth: 240, whiteSpace: "normal", overflowWrap: "anywhere" }}>
            {value}
          </span>
        ),
      },
      {
        Header: "Ubicación",
        accessor: "CurrentLocation",
        align: "left",
        Cell: ({ value }) => (
          <span style={{ display: "inline-block", maxWidth: 240, whiteSpace: "normal", overflowWrap: "anywhere" }}>
            {value}
          </span>
        ),
      },
    ],
    rows: (eliminated || []).map((m) => ({
      Name: machineDisplayName(m),
      MachineTypeType: m?.MachineType?.Type || "No asignado",
      CurrentLocation: getMachineCurrentLocationName(m, "Desechos"),
    })),
  };
}

inactiveMachineTableData.propTypes = {
  eliminated: PropTypes.array.isRequired,
};

